import {type YTPermissionTypeUI} from '../../../utils/acl/acl-api';
import {ACL_CHANGE_FILTERS, AclMode} from '../../../constants/acl';

import {type ActionD} from '../../../types';
import {EMPTY_ARRAY} from '../../../constants/empty';

export interface AclFiltersState {
    approversSubject: string;
    objectSubject: string;
    objectPermissions: Array<YTPermissionTypeUI>;
    columnsFilter: Array<string>;
    columnGroupNameFilter: string;
    rowGroupNameFilter: string;
    rowAccessPredicateFilter: string;

    aclCurrentTab: AclMode;
    expandedSubjects: Set<string | number>;
}

export const initialState: AclFiltersState = {
    approversSubject: '',
    objectSubject: '',
    objectPermissions: [],
    columnsFilter: EMPTY_ARRAY,
    columnGroupNameFilter: '',
    rowGroupNameFilter: '',
    rowAccessPredicateFilter: '',

    expandedSubjects: new Set<string>(),

    aclCurrentTab: AclMode.MAIN_PERMISSIONS,
};

export default (state = initialState, action: AclFiltersAction): AclFiltersState => {
    switch (action.type) {
        case ACL_CHANGE_FILTERS: {
            return {...state, ...action.data};
        }
        default:
            return state;
    }
};

export type AclFiltersAction = ActionD<typeof ACL_CHANGE_FILTERS, Partial<AclFiltersState>>;
